import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import mediaBackground from "assets/images/backgrounds/bg_media.jpg";
import defaultBackground from "assets/images/backgrounds/bg_main.jpg";

const useBackgroundStyles = makeStyles((theme: Theme) =>
    createStyles({
        default: {
            backgroundImage: `url(${defaultBackground})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        },

        media: {
            backgroundImage: `url(${mediaBackground})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        },
    })
);

export default useBackgroundStyles;
